export default "__VITE_ASSET__bc8a21a8__"